module.exports = __webpack_public_path__ + "img/83.dfedeae6.jpg";